"use client";

import { Fragment } from "react";
import type { CodeToken } from "@ui/lib/syntaxHighlighting";
import { _Code } from "./shared";

export function CodeFromTokens({
  tokens,
  raw = false,
  ...props
}: { tokens: CodeToken[][]; raw?: boolean } & Omit<
  React.ComponentPropsWithoutRef<"pre">,
  "children" | "dangerouslySetInnerHTML"
>) {
  return (
    <_Code raw={raw} {...props}>
      <code>
        {tokens.map((line, i) => (
          <Fragment key={i}>
            {line.map((token, index) =>
              typeof token[1] === "undefined" ? (
                token[0]
              ) : (
                <span key={index} style={{ color: token[1] }}>
                  {token[0]}
                </span>
              ),
            )}
            {"\n"}
          </Fragment>
        ))}
      </code>
    </_Code>
  );
}
